import { Input, Button, Form } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import { getUser } from "../../services/localStorage";
import { addConnectionConversion, modifyConnectionConversion } from "./conectionConversionSlice";

export default function AddConnectionConversion(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  React.useEffect(() => {
    if (editBodySize?.id) {

      form.setFieldsValue(editBodySize);
    }
    else {
      form.resetFields();
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    if (editBodySize?.id) {
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyConnectionConversion(values, editBodySize?.id));
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addConnectionConversion(values));
      /* messageApi.open({
        type: "success",
        content: "Data Version added successfully",
      }); */
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Designation (Please input a valid  designation)"
        name="designation"
        rules={[
          {
            required: true,
            message: "Please enter designation",
          },
          {
            pattern: /^[A-Za-z0-9-]+$/,
            message: "Only alphabets, numbers, and '-' are allowed",
          },
        ]}
      >
        <Input id="designation" />
      </Form.Item>

      <Form.Item
        label="Part Number"
        name="part_number"
        rules={[
          {
            required: true,
            message: "Please enter part number",
          },
          {
            pattern: /^[A-Za-z0-9]{1,6}-\d{1,2}-[A-Za-z0-9]{8}$/,
            message: "Format must be XXXXXX-YY-ZZZZZZZZ (6 alphanumeric characters - 2 digits - 8 alphanumeric characters with numbers given priority)",
          },
          {
            max: 18,
            message: "Maximum 18 characters allowed",
          },
        ]}
      >
        <Input id="part_number" maxLength={18} />
      </Form.Item>

      <Form.Item>
        <Button
          style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} 
          type="primary" htmlType="submit"
        // disabled={!form.isFieldsTouched(true) ||
        //   !!form.getFieldsError().filter(({ errors }) => errors.length).length ? true : false} 
        >{editBodySize?.id ? 'Update' : 'Create'}</Button>
      </Form.Item>
    </Form>
  );
}
